import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';

const uploadImageApi = usersApi.injectEndpoints({
  endpoints: (builder: any) => ({
    uploadImage: builder.mutation({
      query: (form: any) => ({
        url: '/notifications/admin/images/',
        method: 'POST',
        body: form,
      }),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      invalidatesTags: (result: { data: { file_path: string } }, error: any) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return result;
      },
    }),
  }),
});

export const { useUploadImageMutation } = uploadImageApi;
